<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="4" style="text-align: start">

                                <strong v-if="status_form==0">{{ $t('components.addCategory') }}</strong>
                                <strong v-else>{{ $t('components.editCategory') }}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: center ;">

                                <strong v-if="status_form!=0">{{edit_name}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">
                                <CButton v-if="status_form ==0" @click="insert_data()"
                                         type="submit" size="sm" class="mr-1 ml-1" color="secondary">
                                    {{ $t('buttons.submit') }}
                                </CButton>
                                <CButton v-if="status_form !=0" @click="insert_data()"
                                         type="submit" size="sm" color="secondary">
                                    {{ $t('buttons.edit') }}
                                </CButton>
                                <CButton v-if="status_form!=0" @click="emptyList()"
                                         class="mr-1"
                                         type="reset" size="sm" color="secondary">
                                    {{ $t("buttons.cancel") }}
                                </CButton>
                                <a :href="$route.fullPath" target="_blank">
                                    <CButton
                                            class="mr-1 ml-1"
                                            size="sm"
                                            color="dark"
                                    >
                                        <CIcon size="sm" name="cil-plus"></CIcon>
                                    </CButton>
                                </a>
                            </CCol>
                        </CRow>
                        <!--        </div>-->

                        <!-- Right aligned nav items -->
                        <!--      </CCollapse>-->
                    </CCardHeader>

                    <CCardBody ref="add_container">
                        <CRow>
                            <CCol cols="4">
                                <CInput
                                        :label="$t('components.categoryName')"
                                        v-model="name"
                                        autocomplete="name"
                                />

                            </CCol>
                            <CCol cols="2">
                                <CSelect
                                        :label="$t('mainGroup')"
                                        :options="items_natures"
                                        :value.sync="selected_nature"
                                />
                            </CCol>


                            <CCol cols="4">
                                <CTextarea
                                        :label="$t('components.summary')"

                                        v-model="description"

                                        rows="1"
                                />
                            </CCol>
                            <!--              <CCol cols="4">-->
                            <!--                <CInput-->
                            <!--                    :label="$t('components.code')"-->
                            <!--                    type="number"-->
                            <!--                    v-model="code"-->
                            <!--                />-->
                            <!--              </CCol>-->
                            <CCol col="3">
                                <CInputFile
                                        :label="$t('components.image')"
                                        custom
                                        horizontal
                                        ref="file_selector"
                                        v-show="false"

                                        v-on:change="handleFileUpload"
                                />
                                <CCol col="12" class="text-center" v-on:click="open_file_selector()"
                                >
                                    <CImg height="100px"
                                          width="100px"
                                          v-model="previewImage"
                                          v-if="previewImage" :src="previewImage"
                                    />
                                </CCol>

                            </CCol>

                        </CRow>


                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow v-show="this.$route.fullPath == '/dashboard/base/inventory-settings' || this.$route.fullPath.startsWith('/dashboard/base/categories/')">
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{ $t('components.categoriesList') }}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol col="3">
                                <CSelect
                                        :label="$t('mainGroup')"
                                        :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                                        :options="items_natures_filter"
                                        :value.sync="selected_nature_filter"
                                />
                            </CCol>
                        </CRow>
                        <CDataTable
                                :items="items_filtered"
                                :fields="fields"
                                column-filter
                                style="height: 250px;overflow: auto"
                                border
                                striped
                                @row-clicked="table_row_clicked"

                                :items-per-page="20"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td style="text-align: center">
                                    <p>{{ item.row_id +1}}</p>

                                </td>

                            </template>

                            <template #color="{item}">

                                <td>
                                    <div :style="get_style(item.color)">
                                        {{ item.color }}
                                    </div>
                                </td>

                            </template>

                            <template #image="{item}">
                                <td>
                                    <CImg width="45px" height="45px" v-bind:src="get_image_file(item)"/>
                                </td>
                            </template>

                            <template #operation="{item,index}">
                                <td>
                                    <!--                  <a class="mr-1"-->

                                    <!--                           square-->
                                    <!--                           size="sm"-->
                                    <!--                           :title="$t('buttons.edit')"-->
                                    <!--                           @click="edit_item(item)"-->
                                    <!--                  >-->
                                    <!--                    <CIcon size="sm" class="text-warning" name="cil-pencil"/>-->
                                    <!--                  </a>-->
                                    <!--                  <CButton class="mr-1"-->

                                    <!--                           square-->
                                    <!--                           :title="$t('buttons.subCategories')"-->
                                    <!--                           size="sm"-->
                                    <!--                           @click="goSubCategories(item,index)"-->
                                    <!--                  >-->
                                    <!--                    <CIcon size="sm" class="primary" name="cilApplications"/>-->
                                    <!--                  </CButton>-->

                                    <!--                  <CButton class="mr-1"-->
                                    <!--                           square-->
                                    <!--                           :title="$t('buttons.products')"-->
                                    <!--                           size="sm"-->
                                    <!--                           @click="goToProductList(item)"-->
                                    <!--                  >-->
                                    <!--                    <CIcon class="text-primary" size="sm" name="cilChart"/>-->
                                    <!--                  </CButton>-->
                                    <CButton class="mr-1"

                                             square
                                             :title="$t('buttons.delete')"
                                             size="sm"
                                             @click="delete_item_dialog(item)"
                                    >
                                        <CIcon class="text-danger" size="sm" name="cilTrash"/>
                                    </CButton>
                                </td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';

    var items = [];


    export default {
        name: 'Login',
        data() {
            return {
                confirm_delete_name: "confirm_category" + new Date().getTime() + "_" + this.$vnode.tag,
                name: '',
                edit_name: '',
                file: null,
                color: '#ffffff',
                code: '',
                items_natures: [],
                items_natures_filter: [],
                selected_nature: [],
                selected_nature_filter: 0,
                previewImage: '/img/placeholder.png',
                description: '',
                items: [],
                items_filtered: [],
                table_clicks: 0,
                table_clicks_timer: null,
                fields: [
                    {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'catTitle', label: this.$t('tables.name'), _style: 'width:25%'},
                    {key: 'code', label: this.$t('tables.code'), _style: 'width:10%'},
                    {key: 'natureTitle', label: this.$t('mainGroup'), _style: 'width:10%'},
                    // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:20%'},
                    // {key: 'color', label: this.$t('tables.color'), _style: 'width:10%;'},
                    {key: 'image', label: this.$t('tables.image'), _style: 'width:10%;'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},


                ],
                details: [],
                collapseDuration: 0,
                status_form: 0
            }
        }, mounted() {
            this.$root.root_validate_errors = [];

            this.get_lists();
            this.get_natures();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            },
            'selected_nature_filter': function () {
                if (this.selected_nature_filter == 0) {
                    this.items_filtered = this.items;

                } else {
                    this.items_filtered = this.items.filter(x => x.natureId == this.selected_nature_filter);

                }
            }
        },
        methods: {
            get_natures() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.$route.params.cat_id);


                axios.post('GetProductNatures', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_natures_filter = [{label: self.$t('all'), value: 0}]
                        self.items_natures = self.sort_array([], content_data.data, "id", 'title');
                        self.items_natures_filter = self.sort_array(self.items_natures_filter, content_data.data, "id", 'title');
                        if (self.items_natures.length > 0) {
                            self.selected_nature = self.items_natures[0].value;

                        }
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.edit_item(item)
                    this.table_clicks = 0

                }
            },
            open_file_selector() {
                this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
            },
            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.name != '' && this.color != '') {
                    return true;
                }


                if (this.name == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
                }

                if (this.color == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
                }
                // if (this.description == '') {
                //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
                // }
                return false;
                // e.preventDefault();
            },
            get_style(color) {
                return {

                    backgroundColor: color

                }
            },
            get_image_file(item) {
                // console.log("image url is " + item.imageName);
                return this.$root.base_url + "/" + item.imageUrl;
            },
            edit_item(item) {
                // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
                this.name = item.catTitle;
                this.edit_name = item.catTitle;
                this.color = item.color;
                this.code = item.code;
                this.description = item.summary;
                this.selected_nature = item.natureId;
                this.previewImage = this.$root.base_url + "/" + item.imageName;
                this.status_form = item.catTitleId;
                setTimeout(() =>
                        this.$refs.add_container.scrollIntoView()
                    , 500);
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '/img/placeholder.png';
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists() {
                var self = this;

                const formData = new FormData();
                var cat_parent_id = 0;
                if (this.$route.params.cat_id != null) {
                    cat_parent_id = this.$route.params.cat_id;
                }
                formData.append('id', cat_parent_id);


                axios.post('GetAllCats', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.items_filtered = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            goSubCategories(item, index) {

                this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goToProductList(item) {
                this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
                // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            handleFileUpload(files, e) {
                console.log("handle upload")
                this.file = e.target.files[0];
                this.previewImage = URL.createObjectURL(this.file);
                e.target.value = '';
                e.target.files = '';

            },
            insert_data() {


                if (!this.validateForm()) {
                    // console.log("validate form is false"+this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddMainCat";
                } else {
                    url = "EditMainCat";
                    formData.append('id', this.status_form)

                }

                formData.append('file', this.file);
                formData.append('MainCatTitle', this.name);
                formData.append('Color', this.color);
                formData.append('NatureId', this.selected_nature);
                formData.append('Code', this.code);
                if (this.$route.params.cat_id != null) {
                    formData.append('IsParent', this.$route.params.cat_id);

                } else {
                    formData.append('IsParent', 0);

                }
                formData.append('summary', this.description);
                axios.post(url, formData, {}).then((res) => {
                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;
                    self.name = '';
                    self.color = '#ffffff';
                    self.code = '';
                    self.description = '';
                    self.previewImage = '/img/placeholder.png';
                    self.get_lists();

                    bus.$emit('close_add_base_modal', 'false');

                }).catch(function (error) {
                    console.log(error);
                });

            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.catTitleId;

            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteCat";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);
                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {
                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
